import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export const getToastIcon = ({ type }: { type: string }) => {
  // theme is not used in this example but you could
  switch (type) {
    case 'info':
      return <ErrorOutlineIcon fontSize="small" className="stroke-indigo-400" />
    case 'error':
      return <ErrorOutlineIcon fontSize="small" className="stroke-red-500" />
    case 'success':
      return <ErrorOutlineIcon fontSize="small" className="stroke-green-500" />
    case 'warning':
      return <ErrorOutlineIcon fontSize="small" className="stroke-yellow-500" />
    default:
      return null
  }
}
